import { Modal, Spin } from "antd"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"

import GiftForm from "../../../../Components/Forms/GiftForm"
import Creators from "../../reducer"

export const GiftModal = ({ modalType, setModalType }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const { saveFetching } = useSelector((state) => state.users)
  const isMobile = useSelector((state) => state.nav.isMobile)

  const handleCloseModal = () => {
    setModalType(false)
  }

  const handleSubmitForm = (data) => {
    dispatch(Creators.giftRequest({ balance: modalType?.balance_id, ...data }))
  }

  return (
    <Modal
      open={modalType?.type === "gift"}
      centered={!isMobile}
      width={410}
      title={t("Gift")}
      footer={null}
      closable="true"
      onCancel={handleCloseModal}
      destroyOnClose
      classNames={{ content: "clear-bg" }}
      getContainer={() => document.getElementById("global-wrap")}
    >
      <Spin size="large" spinning={saveFetching || false}>
        <GiftForm onSubmit={handleSubmitForm} onClose={handleCloseModal} />
      </Spin>
    </Modal>
  )
}
